



































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import moment from "moment";

import {
  ExpenseCategory
} from "@/shared/types";

import Pill from "@/shared/components/ui/Pill.vue";
import Button from "@/shared/components/ui/Button.vue";
import EditExpenseForm from "@/shared/components/expenseV2/EditExpenseForm.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import { expenseCategoryIcon } from "@/shared/awesomeIconMapper";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    Pill,
    Button,
    CurrencyAmount,
    EditExpenseForm
  }
})
export default class UnreimbursedRow extends Vue {
  expenseCategoryIcon = expenseCategoryIcon;
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop({ required: true })
  expense: any; // UnreimburseExpense

  @Prop()
  onReimburseToggle: (UnreimburseExpense) => void;

  @Prop()
  isSelected: boolean;

  isOpen = false;
  markedAsReimbursed = false;

  get buttonText (): string {
    return this.custodianSettingsStore.allowReimbursement ? "Reimburse" : "Reimbursed";
  }

  get expenseCategory (): ExpenseCategory {
    return this.expense.expenseCategory;
  }

  get title (): string {
    return this.expense.name;
  }

  get numberOfAttachments (): number {
    if (this.expense.attachmentNames) {
      return this.expense.attachmentNames.length;
    }

    return 0;
  }

  toggleEdit (e): void {
    e.preventDefault();
    this.isOpen = !this.isOpen;
  }

  onEditClose (): void {
    this.isOpen = false;
  }

  toggleReimbursement (): void {
    if (this.onReimburseToggle) {
      this.onReimburseToggle(this.expense);
    }
  }

  get formattedDate (): string {
    return moment(this.expense.dateOfService).format("MMM D, YYYY");
  }

  get isExpensePartiallyReimbursed (): boolean {
    return this.expense.reimbursedAmount > 0;
  }

  get eligibleAmount (): number {
    return this.expense.amount - this.expense.reimbursedAmount;
  }

  get absoluteEligibleAmount (): number {
    const amount = this.expense.amount;
    return Math.abs(amount);
  }
}

